import { useLocalePath, useT } from "../../i18n";
import { useApi } from "../../lib/api";
import { SectionHeading } from "../SectionHeading";
import { TextLink } from "../TextLink";
import { Reveal } from "../Reveal";
import { VehicleCard, VehicleCardSkeleton } from "../VehicleCard";
import { StateMessage } from "./StateMessage";

export const FeaturedVehicles = ({ index = "01" }) => {
  const t = useT();
  const lp = useLocalePath();
  const { data, loading, error } = useApi("/vehicles/featured");
  const [lead, ...rest] = data || [];
  if (!loading && !error && !data?.length) return null;

  return (
    <section data-testid="featured-section" className="bg-ink py-24 text-white sm:py-32 lg:py-40">
      <div className="container-x">
        <SectionHeading
          index={index}
          eyebrow={t("featured.eyebrow")}
          title={t("featured.title")}
          testId="featured-heading"
          action={<TextLink to={lp("inventory")} testId="featured-view-all">{t("ui.viewAll")}</TextLink>}
        />
        <div className="mt-14 lg:mt-20">
          {loading && (
            <div className="grid gap-12 md:grid-cols-2">
              <VehicleCardSkeleton />
              <VehicleCardSkeleton />
            </div>
          )}
          {!loading && error && <StateMessage error={error} />}
          {lead && (
            <div className="grid gap-14 lg:gap-20" data-testid="featured-grid">
              <Reveal>
                <VehicleCard
                  vehicle={lead}
                  aspect="aspect-[4/3] sm:aspect-[16/9] lg:aspect-[21/9]"
                  titleClass="text-3xl sm:text-4xl lg:text-5xl"
                  sizes="(min-width: 1600px) 1500px, 100vw"
                />
              </Reveal>
              <div className="grid gap-14 md:grid-cols-2 md:gap-8 lg:gap-12">
                {rest.map((v, i) => (
                  <Reveal key={v.id} delay={i * 0.12}>
                    <VehicleCard vehicle={v} aspect="aspect-[4/3] lg:aspect-[3/2]" titleClass="text-2xl sm:text-3xl" sizes="(min-width: 768px) 50vw, 100vw" />
                  </Reveal>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
